import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Card, Table } from 'antd'
import styles from '@Orders/OrderDetailsPage/styles.css'
import {
    intialValues,
    useSalesOrderLineData,
} from '@Orders/OrderDetailsPage/Status/OrderedItems/components/logic'
import {
    OrderedItemsRecordType,
    SalesOrderLineStateType,
} from '@Orders/OrderDetailsPage/Status/OrderedItems/components/types'
import { salesOrderLines_salesOrderLines_items as SalesOrderLineItemType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrderLines'

import MoldItem from './MoldItem'
import getImOrderColumns from './ImOrderColumns'
import { getParts, getSalesItems } from './logic'
import { ImOrderTablePropsType } from './types'

type Params = {
    orderName: string
    tabs?: string
    revisionId?: string
}

const ImOrderTable = (props: ImOrderTablePropsType) => {
    const {
        salesOrderLines,
        isEnabledForIm,
        isImOrder,
        orderName,
        shippedBy,
        getDescriptionData,
        shipmentIdsMap,
        toggleModalForPartViewer,
        onViewInspectionButtonClick,
        onRowClick,
        setActivePage,
        salesOrderShipmentItems,
        setSelectedTab,
    } = props

    const { tabs, revisionId } = useParams<Params>()
    const [threeDInfo, setThreeDInfo] = useState<SalesOrderLineStateType>({
        isPartViewerModalVisible: false,
        ...intialValues,
    })

    const dataSourceOrderedItems = useSalesOrderLineData({
        salesOrderLines: salesOrderLines && getSalesItems(salesOrderLines),
    })

    const dataSourceImOrderItems = salesOrderLines?.items.map(
        (item: SalesOrderLineItemType) => ({
            ...item,
            parts: getParts(dataSourceOrderedItems, item),
        }),
    )

    useEffect(() => {
        if (revisionId) {
            const partData = dataSourceOrderedItems?.find(
                salesItem => salesItem?.qmrId === revisionId,
            )
            // if there is shipment in threeDInfo setup, then use it directly
            const shipment = threeDInfo?.shipment || partData?.shipments?.[0]

            const partViewerState = {
                isPartViewerModalVisible: true,
                shipment,
                ...partData,
            } as SalesOrderLineStateType

            setActivePage(tabs || '')

            setThreeDInfo(partViewerState)
        }

        if (threeDInfo?.dfmReports?.length > 0) {
            const partData = dataSourceOrderedItems?.find(
                item => item.key === threeDInfo?.key,
            )

            const partViewerState = {
                isPartViewerModalVisible: true,
                ...partData,
            } as SalesOrderLineStateType

            setThreeDInfo(partViewerState)
        }
    }, [
        dataSourceImOrderItems,
        dataSourceOrderedItems,
        revisionId,
        setActivePage,
        tabs,
        threeDInfo.dfmReports,
        threeDInfo.key,
        threeDInfo.shipment,
    ])

    const getColumns = (
        partItems: OrderedItemsRecordType[],
        moldStatus: string | null,
    ) => {
        const imOrderColumnProps = {
            isEnabledForIm,
            isImOrder,
            orderName,
            shippedBy,
            getDescriptionData,
            shipmentIdsMap,
            toggleModalForPartViewer,
            onViewInspectionButtonClick,
            partItems,
            moldStatus,
            salesOrderShipmentItems,
            setSelectedTab,
        }

        return getImOrderColumns(imOrderColumnProps)
    }

    const renderPartsTable = (
        parts: {
            [revisionId: string]: OrderedItemsRecordType[]
        },
        moldStatus: string | null,
    ) => {
        return Object.keys(parts).map(partKey => (
            <Table
                key={partKey}
                columns={getColumns(parts?.[partKey], moldStatus)}
                dataSource={parts?.[partKey] || []}
                pagination={false}
                className={classNames(
                    styles.imOrderDetailsTable,
                    styles.shippingTableStyle,
                )}
                showHeader={partKey === Object.keys(parts)?.[0] ? true : false}
                onRow={partData =>
                    onRowClick(
                        partData,
                        toggleModalForPartViewer,
                        setActivePage,
                    )
                }
                data-test-target="order-details-im-order"
            />
        ))
    }

    return (
        <>
            {dataSourceImOrderItems?.map((data, index) => (
                <Card
                    key={data?.id}
                    title={<MoldItem moldItem={data} moldItemIndex={index} />}
                    className={styles.imOrderCard}
                    headStyle={{ borderBottom: '0px', padding: '0 16px' }}
                    bodyStyle={{
                        padding: '16px',
                    }}
                >
                    {renderPartsTable(data?.parts, data?.moldStatus)}
                </Card>
            ))}
        </>
    )
}

export default ImOrderTable
